import {MatrixValue, QuestionValue} from 'common/models/survey';

type ArrayValueType<T> = T extends (infer U)[] ? U : never;
type QuestionArrayValue = ArrayValueType<QuestionValue>;

const isMatrixValue = (value: QuestionValue): value is MatrixValue[] => {
    return (
        Array.isArray(value) &&
        value.length > 0 &&
        (value as Array<QuestionArrayValue>).every<MatrixValue>((item): item is MatrixValue => {
            return Boolean(item) && typeof item === 'object' && 'row' in item && 'column' in item;
        })
    );
};
export default isMatrixValue;
